if (!customElements.get('product-bundle-form')) {
  customElements.define(
    'product-bundle-form',
    class ProductBundleForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')

        // select all inputs and enable
        this.inputs = this.form.querySelectorAll('[name^="id"]')
        this.inputs.forEach((input) => {
          input.disabled = false
        })

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector('cart-drawer') && this.submitButton)
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'

        // Enable the submit button now that the form handler is attached
        // Button starts disabled + pointer-events-none in the template to prevent submission before JS is ready
        if (this.submitButton) {
          const isAvailable = this.submitButton.dataset.initiallyAvailable === 'true'
          // Always remove pointer-events-none since JS is now ready
          this.submitButton.classList.remove('pointer-events-none')
          if (isAvailable) {
            this.submitButton.disabled = false
          }
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove('!hidden')

        const config = fetchConfig('javascript')

        // BUNDLE SPECIFIC
        // get input values from form and add to cart on submit
        const selectedVariants = Array.from(
          document.querySelectorAll('.product-bundle-variant-picker input[name^="id"]')
        ).map((input) => input.value)

        const productsToAdd = selectedVariants.map((variantId) => {
          return { id: variantId, quantity: 1 }
        })

        const formData = {
          items: productsToAdd,
        }
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id)
          formData.sections_url = window.location.pathname
        }

        let body = JSON.stringify(formData)

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig('javascript'),
          ...{ body },
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // publish(PUB_SUB_EVENTS.cartError, {
              //   source: 'product-form',
              //   productVariantId: formData.get('id'),
              //   errors: response.errors || response.description,
              //   message: response.message,
              // });
              this.handleErrorMessage(response.description)

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('!hidden')
              soldOutMessage.classList.remove('!hidden')
              this.error = true
              return
            } else if (!this.cart || window.CART_AB_TEST === 'hybrid-cart') {
              // window.location = window.routes.cart_url;
              // setTimeout(() => {
              //   window.NSHybridCart.open();
              // }, 100);
              return
            }

            // if (!this.error)
            //   publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
            }
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add('!hidden')
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
